import React, { useState } from 'react'
import { useEffect } from 'react';
import axios from 'axios';
import { environment } from '../../env';
import { useParams, useNavigate } from 'react-router-dom';
import "../BuildingViewCard/BuildingDropDown.css"
import moment from 'moment';
import PathName from '../PathName/PathName';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

function QueryViewCard() {
    const user = useSelector((state) => state?.Reducers?.userdata);
    const [querydata, setQueryData] = useState()
    const [comments, setComments] = useState()
    const navigate = useNavigate();
    const { id } = useParams()
    const {
        register,
        handleSubmit,
        reset,
    } = useForm();

    const submit = async (data) => {
        let payload = { comment: data?.comment, query: id, name: user?.first_name + " " + user?.last_name }
        axios.post(`${environment.baseUrl}query-comment`, payload).then(res => {
            if (res?.data?.code === 200) {
                toast.success(res?.data?.message)
                reset();
                getCommets()
            } else {
                console.log("err")
            }
        })
    }
    const getCommets = () => {
        axios.get(`${environment.baseUrl}get-query-comment/${id}`).then((res) => setComments(res?.data))
    }
    const clear = () => {
        reset({
            "comment": ""
        });
        toast.success('comment clear')
    }
    const viewBuildingData = () => {
        axios.get(`${environment.baseUrl}edit-query/${id}`).then(res => setQueryData(res.data)).catch(res => console.log("errorss", res))

    }
    useEffect(() => {
        viewBuildingData();
        getCommets()
    }, [])

    return (
        <>
            <PathName />
            <div className="d-flex justify-content-between align-items-center py-5 px-3 pt-2">
                <button className="d-flex align-items-center border-0 bg-transparent" onClick={() => navigate(-1)}>
                    <i className='bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left'></i>
                    <span className='fs-3 base-font-600'>Back</span> </button>
            </div>
            <div className="bg-white d-flex mb-5  flex-column border-radius-32">
                <div className="card w-100 border-0 rounded-5">
                    <div className="row g-0 border-bottom p-5">
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className='fs-2 base-font-700 text-base-color mb-3'>INVESTOR DETAILS</h5>
                                <h5 className="fs-3 base-font-700 mb-4">Investor Name : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.Investors?.name}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Mobile : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.Investors?.contact_number}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Email : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.Investors?.email}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Address1 : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.Investors?.address}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Address2 : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.Investors?.corsp_address}</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className='fs-2 base-font-700 text-base-color mb-3'>PROPERTY DETAILS</h5>
                                <h5 className="fs-3 base-font-700 mb-4">Building : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.building?.building_no}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Gala : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.gala?.gala_no}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Sub Gala : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.sub_gala_name}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Area : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.sold_gala_area}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Owner Type : <span className='fs-3 base-font-400'>{querydata?.gala_investor?.ownertype}</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className='fs-2 base-font-700 text-base-color mb-3'>QUERY DETAILS</h5>
                                <h5 className="fs-3 base-font-700 mb-4">Status: <span className='fs-3 base-font-400'>{querydata?.status}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Assigned To : <span className='fs-3 base-font-400'>{querydata?.assign == '' ? 'Not Assigned' : querydata?.assign}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Created On : <span className='fs-3 base-font-400'>{moment(querydata?.created_at).format('DD/MM/YYYY')}</span> </h5>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0  p-5">
                        <div className="col-md-12">
                            <div className="">
                                <h5 className='fs-2 base-font-700 text-base-color mb-3 text-uppercase'>Query Info Comments</h5>
                                <h5 className="fs-3 base-font-700 mb-4 text-capitalize">{querydata?.comment}</h5> 
                                <form onSubmit={handleSubmit(submit)}>
                                    <div className="border-bottom-color-1 p-3 pb-5  ">
                                        <div className="d-flex align-items-center gap-2 ">
                                            <h2 className="text-base-black base-font-600 btn fs-2 py-2 px-4 text-capitalize" style={{ backgroundColor: "#6270de70", borderRadius: "6px 6px 6px 0px" }}>{user?.first_name + " " + user?.last_name}</h2>
                                        </div>
                                        <div className="p-3" style={{ backgroundColor: "#e1e1e1", borderRadius: "0px 10px 10px 10px" }}>
                                            <textarea rows={3} className="base-font-500 fs-2  border-0 w-100 p-2 " style={{ borderRadius: "0px 10px 10px 10px", outline: "none" }} placeholder='Please Enter Your Comments'  {...register("comment")}></textarea>
                                            <div className="d-flex justify-content-end pt-3 gap-4">
                                                <button className='btn py-2 px-4 base-font-600 fs-2 bg-base-color text-white' >Send</button>
                                                <button type='button' onClick={clear} className='btn py-2 px-4 base-font-600 fs-2 bg-danger text-white'>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                {comments?.map((comment, i) => {
                                    return (
                                        <div className="border-bottom-color-1 p-3  mt-5" key={i}>
                                            <div className="d-flex align-items-center gap-2 ">
                                                <h2 className="text-base-black base-font-600 btn fs-2 py-2 px-4 text-capitalize" style={{ backgroundColor: "#6270de70", borderRadius: "6px 6px 6px 0px" }}>{comment?.name}</h2>
                                                <h2 className="text-base-black title-font-600 btn fs-2 py-2 px-4 text-capitalize">{moment(comment?.created_at).format('DD/MM/YYYY')} <span className='base-font-500 text-base-gray fs-2'>({moment(comment?.created_at).fromNow()})</span></h2>
                                            </div>
                                            <div className="p-3" style={{ backgroundColor: "#e1e1e1", borderRadius: "0px 10px 10px 10px" }}>
                                                <p className="base-font-500 fs-2 " >{comment?.comment}</p>
                                            </div>
                                        </div>
                                    )
                                })
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default QueryViewCard